import script from "./TimerexModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TimerexModal.vue?vue&type=script&setup=true&lang=ts"

import "./TimerexModal.vue?vue&type=style&index=0&id=234955f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-234955f4"]])

export default __exports__